var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.values)?_c('div',[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.handleExport}},[_vm._v(" Exportar a EXCEL ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }